import PhoneInput from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'
import 'react-phone-number-input/style.css'
import { Phone } from 'lucide-react'

/**
 * Supported European countries for phone input.
 * French-speaking + nearby European states.
 *
 * FR  France       +33
 * BE  Belgium      +32
 * CH  Switzerland  +41
 * LU  Luxembourg   +352
 * MC  Monaco       +377
 * AD  Andorra      +376
 * IT  Italy        +39
 * ES  Spain        +34
 * PT  Portugal     +351
 */
export const SUPPORTED_COUNTRIES = ['FR', 'BE', 'CH', 'LU', 'MC', 'AD', 'IT', 'ES', 'PT']

/**
 * Reusable international phone input with country flag selector.
 *
 * Designed for use with react-hook-form's Controller component.
 * Only allows phone numbers from the supported European countries.
 *
 * @param {Object}  props
 * @param {string}  props.value          - E.164 phone value (e.g. "+33612345678")
 * @param {Function} props.onChange       - Called with new E.164 value
 * @param {Function} [props.onBlur]      - Called on blur (for react-hook-form)
 * @param {string}  [props.error]        - Error message to display
 * @param {string}  [props.defaultCountry] - ISO country code for default selection
 * @param {string}  [props.placeholder]  - Input placeholder text
 */
function PhoneInputField({
  value,
  onChange,
  onBlur,
  error,
  defaultCountry = 'FR',
  placeholder = 'Ex: 06 12 34 56 78',
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        <Phone className="inline w-4 h-4 mr-2" />
        Téléphone *
      </label>

      <div
        className={`
          phone-input-wrapper
          ${error ? 'phone-input-wrapper--error' : ''}
        `}
      >
        <PhoneInput
          international
          defaultCountry={defaultCountry}
          countries={SUPPORTED_COUNTRIES}
          flags={flags}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          countryCallingCodeEditable={false}
        />
      </div>

      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
}

export default PhoneInputField
